import * as React from 'react';
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useAuth } from '../../../components/AuthProvider';
import logo from '../login/logo_black.png'
import { useNavigate, useLocation } from 'react-router-dom';
import { Paper } from '@mui/material';
import api from '../../../services/api';
import CustomTextField from '../../../components/CustomTextField';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function SignIn() {
  const navigate = useNavigate()
  const auth = useAuth()
  const query = useQuery()
  const source = query.get('source') || 'admin'

  React.useEffect(() => {
    document.title = "IPV7 - Recuperar Senha"
    if (auth.user != null) {
      navigate('/')
    }
  }, [auth.user, navigate])


  const [errorInput, setErrorInput] = React.useState({
    username: false,
    password: false,
  })
  const [errorMsg, setErrormsg] = React.useState({
    severity: "error",
    msg: "",
    show: false
  })
  const loginApi = (cred) => {
    let from = location.state?.from?.pathname || "/";
    const redirectTo = () => {

      navigate(from, { replace: true })
    }
    const cbErr = () => setErrormsg({
      msg: "Credenciais inválidas.", show: true, severity: 'error'
    })
    auth.signin(cred, redirectTo, cbErr)

  }

  const handleSubmit = (event) => {
    setErrorInput(obj => ({ ...obj, username: false, password: false }))
    setErrormsg(errorMsg => ({ ...errorMsg, show: false }))
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const cred = ({
      email: data.get('email'),

    });


    if (cred.email.length < 5) {
      setErrorInput(obj => ({ ...obj, email: true }))
    }
    if (!cred.email) {
      setErrormsg(m => ({ show: true, msg: "Por favor preencha o formulário corretamente.", severity: 'warning' }))
      return;
    }
    const loginUrl = source === 'admin' ? '/admin/login' : '/login'

    // A tela nao pode afirmar que o e-mail foi enviado, porque o servidor
    // deliberadamente nao diz se a conta existe: dizer "enviado" para um
    // endereco desconhecido manda a pessoa esperar um e-mail que nunca vem, e
    // dizer "nao encontrado" entregaria quais contas existem, que e o que a
    // rota passou a esconder. O texto vem do proprio servidor.
    api.post("recovery/", { ...cred, source }).then((res) => {
      setErrormsg({
        show: true,
        msg: res.data?.message || "Se este e-mail estiver cadastrado, enviaremos as instruções.",
        severity: 'success'
      })
      setTimeout(() => navigate(loginUrl), 4000)
    }).catch((err) => {
      const status = err.response?.status
      let msg = "Erro ao enviar email. Tente novamente."
      if (status === 429) msg = "Muitas tentativas. Aguarde 1 minuto."
      setErrormsg({ show: true, msg, severity: 'error' })
    })
  };

  return (

    <Container component="main" maxWidth={false}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: "#2B2E35",
        }}
      >
      <CssBaseline />
      <Container maxWidth="xs" sx={{ mb: 4 }}>

      <Paper elevation={2}
            sx={{
              p: 5,
              backgroundColor: "#EDF1FC",
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >

          <img  style= {{ width: '100%'}} src={logo}></img>


          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>

            <CustomTextField
              error={errorInput.email}
              margin="normal"
              required
              fullWidth
              name="email"
              minLength="8"
              label="Insira seu email"
              type="email"
              id="email"
              autoComplete="current-email"
              helperText={errorInput.email ? "Verifique este campo." : ''}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Recuperar senha
            </Button>
            <Alert severity={errorMsg.severity}
              sx={{ display: errorMsg.show ? '' : 'none' }}
            >{errorMsg.msg}</Alert>
          </Box>
        </Paper>
      </Container>
    </Container>

  );
}
